module.exports = __webpack_public_path__ + "static/media/file-arrow.16c5749c.svg";